import { type IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { Icon } from "@tenant/ui";
import styles from "./PerkDialogs.module.scss";

interface PerkDialogItemProps {
  iconName: IconNameEnum;
  title: string;
  children: React.ReactNode;
}

export const PerkDialogItem = ({
  iconName,
  title,
  children,
}: PerkDialogItemProps) => {
  const [, cn] = useModuleBEM(styles, "PerkDialogs");

  return (
    <div className={cn("item-container")}>
      <div className={cn("item-element")}>
        <Icon
          iconName={iconName}
          className={cn("item-icon")}
          useCurrentColor={false}
        />
        <div className={cn("item-content")}>
          <p className={cn("item-title")}>{title}</p>
          {children}
        </div>
      </div>
    </div>
  );
};
